<template>
  <div class="modal fade" :id="id" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ $t('projectsTransferred.transferProjectToUser') }}
            </h5>
            <div
                class="btn btn-icon btn-sm btn-active-light-primary ms-2"
                @click="closeModal"
            >
              <span class="svg-icon svg-icon-1">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                  <rect
                      opacity="0.5"
                      x="6"
                      y="17.3137"
                      width="16"
                      height="2"
                      rx="1"
                      transform="rotate(-45 6 17.3137)"
                      fill="currentColor"
                  />
                  <rect
                      x="7.41422"
                      y="6"
                      width="16"
                      height="2"
                      rx="1"
                      transform="rotate(45 7.41422 6)"
                      fill="currentColor"
                  />
                </svg>
              </span>
            </div>
          </div>

          <div class="modal-body">
            <RequiredText />

            <div class="row">
              <div class="col-md-6">
                <Select2
                    :parent-id="'#' + id"
                    :name="'source_user_' + id"
                    :multiple="false"
                    labelClass="form-label fs-6 text-black"
                    :label="$t('projects.users')"
                    selectClass="form-select form-select-solid"
                    :isRequired="true"
                    :placeholderText="$t('projectsTransferred.selectUserToRemove')"
                    @update:modelValue="handleSelectedSourceUser"
                    v-model="formData.from_user_id"
                >
                  <option v-for="user in users" :value="user?.id" :key="user?.id">
                    {{ user.fullname }}
                  </option>
                </Select2>
              </div>
              <div class="col-md-6">
                <Select2
                    :parent-id="'#' + id"
                    :name="'target_user_' + id"
                    :multiple="false"
                    labelClass="form-label fs-6 text-black"
                    :label="$t('projectsTransferred.to')"
                    selectClass="form-select form-select-solid"
                    :isRequired="true"
                    :placeholderText="$t('projectsTransferred.selectUserToAdd')"
                    v-model="formData.to_user_id"
                >
                  <option v-for="user in users" :value="user?.id" :key="user?.id">
                    {{ user.fullname }}
                  </option>
                </Select2>
              </div>
            </div>


            <Loader :is-loading="fetching" class="mt-4">
              <div class="mt-5">
                <div class="form-check mb-3">
                  <input
                      type="checkbox"
                      class="form-check-input"
                      id="selectAll"
                      v-model="selectAll"
                      @change="toggleSelectAll"
                  />
                  <label class="form-check-label" for="selectAll">
                    {{ $t('projects.label.selectAll') }}
                  </label>
                </div>

                <div
                    v-for="project in selectedUserProjects"
                    :key="project.id"
                    class="form-check mb-3"
                >
                  <input
                      class="form-check-input"
                      type="checkbox"
                      :value="project.id"
                      v-model="formData.project_ids"
                      :disabled="selectAll"
                  />
                  <label class="form-check-label">{{ project.title }}</label>
                </div>
              </div>
            </Loader>


          </div>

          <div class="modal-footer">
            <Button
                type="cancel"
                id="cancel_btn"
                btn-class="btn-sm me-3"
                size="7px 30px"
                btn-text="button.cancel"
                @click="closeModal"
            />
            <Button
                btn-class="btn-sm me-3"
                type="submit"
                id="submit_btn"
                btn-text="button.save"
                size="7px 30px"
                :is-loading="isLoading"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps, computed, onMounted } from "vue";
import { useStore } from "vuex";
import Button from "@/components/Button.vue";
import RequiredText from "@/components/RequiredText.vue";
import Select2 from "@/components/Select2.vue";
import Loader from "@/components/Loader.vue";

const store = useStore();

const emits = defineEmits(['callback'])

const props = defineProps({
  id: { type: String, required: true },
});

const isLoading = ref(false);
const fetching = ref(false);
const selectedUserProjects = ref([]);
const selectAll = ref(false);

const formData = ref({
  from_user_id: "",
  to_user_id: "",
  project_ids: [],
});

const users = computed(() => store.getters["user/getUsers"]);

function closeModal() {
  $("#" + props.id).modal("toggle");
}

function handleSelectedSourceUser(id) {
  fetching.value = true;
  selectedUserProjects.value = [];
  selectAll.value = false;
  formData.value.project_ids = [];

  store
      .dispatch("projectsTransferred/getUserProjects", { user_id: id })
      .then((res) => {
        selectedUserProjects.value = res.data.data || [];
      })
      .finally(() => (fetching.value = false));
}

function toggleSelectAll() {
  if (selectAll.value) {
    formData.value.project_ids = [];
  }
}

function submitForm() {
  isLoading.value = true;

  store
      .dispatch("projectsTransferred/transferProjectToUser", formData.value)
      .then(() => {
        isLoading.value = false;
        emits('callback')
        closeModal();
        window.toastr["success"](i18n.global.t("projectsTransferred.users_added_successfully"));
      })
      .catch(() => (isLoading.value = false));
}

onMounted(() => {
  store.dispatch("user/loadUsers");
});
</script>

<style scoped></style>
